import React, {Dispatch, FC, MouseEventHandler, SetStateAction, useState} from "react";
import {LearnCategory, LearnModule} from "../../../lib/src/api/repositories/learn-repository";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAsterisk, faCheck, faPencil, faBoxArchive} from "@fortawesome/free-solid-svg-icons";
import {useNavigate} from "react-router-dom";
import {RoundedContextMenu} from "../../../lib/src/components/content/ContextMenu";
import {EditLearnModuleModal} from "../modals/EditLearnModuleModal";
import {ArchiveLearnModuleModal} from "../modals/ArchiveLearnModuleModal";
import {faArrowsLeftRight, faRotateLeft} from "@fortawesome/pro-solid-svg-icons";
import {MoveLearnModuleModal} from "../modals/MoveLearnModuleModal";
import {useModal} from "@jane/lib/src/components/layout/ModalProvider";

export  const ModuleList: FC<{ modules: LearnModule[], categories: LearnCategory[], reload: () => void, selected: string[], setSelected: Dispatch<SetStateAction<string[]>> }> = (props) => {
  return <>
  {props.modules.length > 0 ? <>
    {props.modules.map((module, index) => {
      return <ModuleRow
        key={index}
        module={module}
        modules={props.modules}
        categories={props.categories}
        isFirst={index === 0}
        isLast={index === props.modules.length - 1}
        selectedModules={props.selected}
        setSelectedModules={props.setSelected}
        toggleSelectModule={(id) => {
          props.setSelected(old => old.includes(id) ? old.filter(x => x !== id) : [...old, id])
        }}
        reload={props.reload}
      />
    })}
  </> : <>
    <div className={'px-4 py-3 border bg-white border-slate-200 rounded-sm flex justify-center items-center'}>
      <div>Geen modules in deze categorie</div>
    </div>
  </>}
  </>
}

const ModuleRow: FC<{
  module: LearnModule,
  modules: LearnModule[],
  categories: LearnCategory[],
  isFirst: boolean,
  isLast: boolean,
  selectedModules: string[],
  setSelectedModules: Dispatch<SetStateAction<string[]>>,
  toggleSelectModule: (id: string) => void,
  reload: () => void,
}> = (props) => {
  const navigate = useNavigate();
  const { open: editModuleModal } = useModal({title: "Module bewerken", body: <EditLearnModuleModal module={props.module} onFinished={props.reload} />, size: "md"})
  const { open: archiveModuleModal } = useModal({title: "Module Archiveren", body: <ArchiveLearnModuleModal module={props.module} onFinished={props.reload} />, size: "md"})
  const { open: unarchiveModuleModal } = useModal({title: "Module Terugzetten", body: <ArchiveLearnModuleModal module={props.module} onFinished={props.reload} />, size: "md"})
  const { open: moveModuleModal } = useModal({title: "Module Verplaatsen", body: <MoveLearnModuleModal moduleId={props.module.id} categories={props.categories} onFinished={props.reload} />, size: "md"})
  return <div className={`flex items-center py-3 bg-white border-slate-200 ${props.isFirst ? 'rounded-t border' : 'border-b border-l border-r'} ${props.isLast ? 'rounded-b' : ''} group hover:bg-brand-50 hover:cursor-pointer`}
              onClick={() => navigate(`/learn/modules/${props.module.id}`)}>
    <div className={'pr-3'}>
      <CheckBox
        state={props.selectedModules.includes(props.module.id) ? 'checked' : 'unchecked'}

        onSelect={() => {
          props.setSelectedModules(prev => {
            return [...prev, props.module.id];
          });
        }}

        onDeselect={() => {
          props.setSelectedModules(prev =>  prev.filter(id => id !== props.module.id));
        }}
      />
    </div>

    <div className={'flex flex-col flex-1 justify-center px-3'}>
      <div className={'flex flex-row space-x-3'}>
        <div>{props.module.name}</div>
        <div className={'flex self-center py-0.5 px-1 text-xs font-medium rounded-sm border border-brand-on-primary-container uppercase'}>{props.module.certificate_type}</div>
      </div>
      <div className={'text-xs'}>{props.module.description}</div>
    </div>

    {props.module.archived_at &&
      <div className={'px-3 py-0.5 mr-2 font-medium text-xs text-white bg-brand-600 rounded-full'}><FontAwesomeIcon icon={faBoxArchive} className={'mr-1.5'} />Gearchiveerd</div>
    }

    {props.module.mandatory &&
      <div className={'px-3 py-0.5 mr-2 font-medium text-xs text-white bg-brand-600 rounded-full'}><FontAwesomeIcon icon={faAsterisk} className={'mr-1.5'} />Verplicht</div>
    }

    <RoundedContextMenu options={[
      {icon: faPencil, label: 'Bewerk', onClick: () => editModuleModal()},
      {icon: faArrowsLeftRight, label: 'Verplaatsen', onClick: () => moveModuleModal()},
      ...(props.module.archived_at ?
      [{icon: faRotateLeft, label: 'Terugzetten', onClick: () => unarchiveModuleModal()}] :
      [{icon: faBoxArchive, label: 'Archiveren', onClick: () => archiveModuleModal()}]),
    ]} />
  </div>
}

const CheckBox: FC<{state: 'checked'|'unchecked', onSelect: () => void, onDeselect: () => void}> = props => {
  const handleClick: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation()
    if (props.state === 'checked') {
      props.onDeselect()
    } else {
      props.onSelect()
    }
  }
  return <button onClick={handleClick} type={'button'} className={'ml-2 -mr-2 hover:bg-brand-surface-variant rounded-full flex items-center justify-center'}>
    <div className={`h-4 w-4 mx-3 my-3 flex items-center justify-center rounded-sm border-2 ${props.state === 'unchecked' ? 'border-brand-secondary bg-transparent' : 'border-brand-primary bg-brand-primary text-brand-on-primary'}`}>
      {props.state === 'checked' && <FontAwesomeIcon icon={faCheck} className={'w-3'} />}
    </div>
  </button>
}